import * as yup from 'yup';

import { Button } from '../../component/common/button/Button';
import { RowActionsDropdown } from '../../component/common/table/action-dropdown/RowActionsDropdown';

export const getMenuColumnDefinition = (
  onEdit,
  onView,
  onDelete,
  customAction,
  customActionText,
  customActionIcon
) => [
  {
    id: 'title',
    accessorKey: 'title',
    size: 180,
    minSize: 180,
    header: 'Title',
    filterFn: 'tableFilterFn'
  },
  {
    id: 'actions',
    header: '',
    size: customAction ? 100 : 40,
    minSize: customAction ? 100 : 40,
    maxSize: customAction ? 100 : 40,
    disableExport: true,
    enableSorting: false,
    cell: ({ row }) => {
      if (customAction && typeof customAction === 'function') {
        return (
          <Button onClick={() => customAction(row.original)} small outline>
            {customActionIcon}
            {customActionText}
          </Button>
        );
      }

      const availableActions = [
        onView && { label: 'View', value: 'view', onSelect: onView },
        onEdit && { label: 'Edit', value: 'edit', onSelect: onEdit },
        onDelete && { label: 'Delete', value: 'delete', onSelect: onDelete }
      ].filter(Boolean);

      return <RowActionsDropdown row={row} actions={availableActions} />;
    }
  }
];

export const MENU_TABS = () => [
  {
    label: 'Details',
    fields: [
      {
        type: 'input',
        name: 'title',
        label: 'Title',
        required: true,
        validation: yup.string().required('Title is required')
      }
    ]
  }
];
